import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Button, Card, Table, message } from "antd";
import { useState } from "react";
import { ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
// import AxiosInstance from "../../AxiosInstance";
import OtherPageHeader from "../../../components/OtherHeader";
import moment from "moment";
import { Modal } from "react-bootstrap";
import RoleSwitch from "../../Helper/RoleSwitch";
import { useForm } from "react-hook-form";
import { amountFormat } from "../../../utils";
import AssignModel from "../../../components/Model/AssignModel/AssignModel";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CompleteProfileModel from "../../../components/Model/CompleteProfileMode";
import AxiosInstance from "../../../AxiosInstance";

export default function PHMaturedPolicies() {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
  const navigate = useNavigate();
  var [loading, setLoading] = useState(true);
  var [policies, setPolicies] = useState([]);
  var [userRoles, setUserRoles] = useState([]);
  var [userMeData, setUserStatus] = useState("");
  var [dataSource, setDataSource] = useState([]);
  const [showReject, setShowReject] = useState(false);
  var [summaryData, setSummaryData] = useState([]);
  const [rejectionReason] = useState(false);
  const [requestModal, setRequestModal] = useState(false);
  const [partnerCodeModal, setPartnerCodeModal] = useState(false);
  const [skip, setSkip] = useState(0);
  const [paginationMetaData, setPaginationMetaData] = useState({});
  const [active, setActive] = useState(true);
  const handleClose = () => setShowReject(false);
  const handleShow = () => setShowReject(true);
  const [messageApi, contextHolder] = message.useMessage();
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    reset,
  } = useForm({ mode: "onChange" });
  var [userName, setUserName] = useState("UserName");
  const getSummary = () => {
    const url = "/policy/summary?isMatured=true";
    AxiosInstance()
      .get(url)
      .then((resp) => {
        setSummaryData(resp.data);
      });
  };

  const updatePolicy = (policy) => {
    navigate("/policydetails", {
      state: {
        policy,
      },
    });
  };
  const policyButtons = (policy, type) => {
    if (policy["status"] === "NOT_UPDATED") {
      return (
        <button
          className="tableButton-ph"
          onClick={() => {
            updatePolicy(policy);
          }}
        >
          {"Update Details"}
        </button>
      );
    } else if (
      policy["status"] === "PENDING" ||
      policy["status"] === "SUPERVISOR_PENDING"
    ) {
      return <button className="tableButton-ph">{"Under Review"}</button>;
    } else if (policy["status"] === "REJECTED") {
      return (
        <button
          className="tableButton-ph"
          style={{ backgroundColor: "red", color: "white" }}
          onClick={() => {
            updatePolicy(policy);
          }}
        >
          {"Policy Rejected"}
        </button>
      );
    }

    // switch work only when policy is approved
    switch (type) {
      case "loan":
        if (policy["loanStatus"] === "NOT_APPLIED") {
          return (
            <button
              className="tableButton-ph"
              onClick={() => {
                // applyService("loan", policy.policyId);
              }}
            >
              {"Apply for Loan"}
            </button>
          );
        } else if (policy["loanStatus"] === "APPLIED") {
          return (
            <button
              className="tableButton-ph"
              style={{ backgroundColor: "#D3D3D3" }}
            >
              {"Applied"}
            </button>
          );
        } else if (policy["loanStatus"] === "SENT") {
          return (
            <button className="tableButton-ph">{"Request Sent to Bank"}</button>
          );
        } else if (policy["loanStatus"] === "APPROVED") {
          return <button className="tableButton-ph">{"Loan Approved"}</button>;
        } else if (policy["loanStatus"] === "REJECTED") {
          return <button className="tableButton-ph">{"Loan Rejected"}</button>;
        } else if (policy["loanStatus"] === "PAYMENT_PENDING") {
          return (
            <button className="tableButton-ph">{"Loan Under Process"}</button>
          );
        } else if (policy["loanStatus"] === "PAYMENT_DONE") {
          return <button className="tableButton-ph">{"Loan Disbursed"}</button>;
        }
        //  else {
        //   return (
        //     <button
        //       className="tableButton-ph"
        //       style={{ backgroundColor: "#D3D3D3" }}
        //     >
        //       {"Applied for loan"}
        //     </button>
        //   );
        // }
        break;

      case "premiumFinanceStatus":
        if (policy["premiumFinanceStatus"] === "NOT_APPLIED") {
          return (
            <button
              className="tableButton-ph"
              onClick={() => {
                // applyService("premium", policy.policyId);
              }}
            >
              {"Get Premium Finance"}
            </button>
          );
        } else if (policy["premiumFinanceStatus"] === "APPLIED") {
          return (
            <button
              className="tableButton-ph"
              style={{ backgroundColor: "#D3D3D3" }}
            >
              {"Applied"}
            </button>
          );
        } else if (policy["premiumFinanceStatus"] === "SENT") {
          return (
            <button className="tableButton-ph">{"Request Sent to Bank"}</button>
          );
        } else if (policy["premiumFinanceStatus"] === "APPROVED") {
          return (
            <button className="tableButton-ph">{"Financing Approved"}</button>
          );
        } else if (policy["premiumFinanceStatus"] === "REJECTED") {
          return (
            <button className="tableButton-ph">{"Financing Rejected"}</button>
          );
        } else if (policy["premiumFinanceStatus"] === "PAYMENT_PENDING") {
          return <button className="tableButton-ph">{"Under Process"}</button>;
        } else if (policy["premiumFinanceStatus"] === "PAYMENT_DONE") {
          return <button className="tableButton-ph">{"Disbursed"}</button>;
        }

        break;

      case "assignmentStatus":
        if (
          policy["assignmentStatus"] === "NOT_APPLIED" ||
          policy["assignmentStatus"] === "REJECTED"
        ) {
          return (
            <button
              className="tableButton-ph"
              onClick={() => {
                // applyService("assignment", policy.policyId);
              }}
            >
              {"Apply for Assignment"}
            </button>
          );
        } else if (
          policy["assignmentStatus"] === "APPLIED" ||
          policy["assignmentStatus"] === "PENDING"
        ) {
          return (
            <button
              className="tableButton-ph"
              style={{ backgroundColor: "#D3D3D3" }}
            >
              {"Applied"}
            </button>
          );
        } else if (policy["assignmentStatus"] === "SENT") {
          return (
            <button className="tableButton-ph">{"Sent to Insurer"}</button>
          );
        } else if (policy["assignmentStatus"] === "APPROVED") {
          return (
            <button className="tableButton-ph">{"Request Approved"}</button>
          );
        }
        //  else if (policy["assignmentStatus"] === "REJECTED") {
        //   return (
        //     <button className="tableButton-ph">{"Request Declined"}</button>
        //   );
        // }
        else if (policy["assignmentStatus"] === "PAYMENT_PENDING") {
          return (
            <button className="tableButton-ph">{"Investor Payment Due"}</button>
          );
        } else if (policy["assignmentStatus"] === "PAYMENT_DONE") {
          return <button className="tableButton-ph">{"Assigned"}</button>;
        }
        //  else {
        //   return (
        //     <button
        //       className="tableButton-ph"
        //       style={{ backgroundColor: "#D3D3D3" }}
        //     >
        //       {"Applied for Assignment"}
        //     </button>
        //   );
        // }
        break;

      default:
        return <></>;
    }
  };

  const columns = [
    {
      title: "Insurer",
      dataIndex: "insurerLogo",
      key: "insurerLogo",
      render: (text, policy) => (
        <>
          <img
            className="insurer-logo"
            alt="insurerlogo"
            src={policy["insurerLogo"]}
          />
        </>
      ),
    },

    {
      title: "Policy Number",
      dataIndex: "policyNumber",
      key: "policyNumber",
      align: "center",
    },
    {
      title: "₹ Premium Amount",
      dataIndex: "annualPremium",
      key: "annualPremium",
      width: 160,
      render: (text, policy) => (
        <>{amountFormat(policy["annualPremium"]) ?? "N/A"}</>
      ),
      align: "right",
    },
    {
      title: "₹ Sum Assured",
      dataIndex: "sumAssured",
      key: "sumAssured",
      width: 160,
      render: (text, policy) => (
        <>{amountFormat(policy["sumAssured"]) ?? "N/A"}</>
      ),
      align: "right",
    },
    {
      title: "₹ Surrender Value",
      dataIndex: "surrenderValue",
      key: "surrenderValue",
      width: 160,
      render: (text, policy) => (
        <>{amountFormat(policy["surrenderValue"]) ?? "N/A"}</>
      ),
      align: "right",
    },
    {
      title: "₹ Loan Eligible",
      dataIndex: "loanEligibility",
      key: "loanEligibility",
      width: 190,
      render: (text, policy) => (
        <div className="ph-dashboard-container">
          {amountFormat(policy["eligibleLoan"]) ?? "N/A"}
          <br />
          {policyButtons(policy, "loan")}
        </div>
      ),
      align: "right",
    },
    {
      title: "₹ Premium Finance",
      dataIndex: "premiumFinance",
      key: "premiumFinanceStatus",
      width: 190,
      render: (text, policy) => (
        <div className="ph-dashboard-container">
          {amountFormat(policy["eligibleFinance"]) ?? "N/A"}
          <br />
          {policyButtons(policy, "premiumFinanceStatus")}
        </div>
      ),
      align: "right",
    },
    {
      title: "₹ Assignment Offer",
      dataIndex: "assignmentStatus",
      key: "assignmentStatus",
      width: 190,
      render: (text, policy) => (
        <div className="ph-dashboard-container">
          {amountFormat(Math.round(policy["assignmentOfferAmount"])) ?? "N/A"}
          <br />
          {policyButtons(policy, "assignmentStatus")}
        </div>
      ),
      align: "right",
    },
  ];
  let ignore = false;

  useEffect(() => {
    if (!ignore) getPolicyData(0);
    return () => {
      ignore = true;
    };
  }, []);

  const getPolicyData = async (skip) => {
    const url = `policy/policyList?take=10&skip=${skip}&isMatured=true`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        setPolicies(data.data);
        var temp = [];
        data.data.forEach((element) => {
          temp.push({
            ...element,
            insurerLogo: element.insurer.logo,
          });
        });
        setDataSource(temp);
        setPaginationMetaData(data.paginationMetaData);
        setLoading(false);
      })
      .catch((err) => {});
    // getUserMe();
    getSummary();
  };
  const change = (data) => {
    setSkip((data - 1) * 10);
    getPolicyData((data - 1) * 10);
  };

  var SummaryComponent = () => {
    return (
      <>
        <div className="ph-summary grid-container">
          <div>
            <div>
              {" "}
              <span className="heading-ph">Policy Holder</span>
              <br />
              <span className="heading-ph ">Dashboard</span>
              <p>(Aggregate of all matured policies)</p>
            </div>
          </div>
          <div>
            <div className="key">Sum Assured</div>
            <div className="value">
              ₹{" "}
              {summaryData
                ? amountFormat(Math.round(summaryData.totalSumAssured))
                : "-"}
            </div>

            <div className="key mt-4">Assignment Value</div>
            <div className="value">
              ₹{" "}
              {summaryData
                ? amountFormat(Math.round(summaryData.totalAssignmentValue))
                : "-"}
            </div>
          </div>
          <div>
            <div className="key">Premium Value</div>
            <div className="value">
              ₹{" "}
              {summaryData
                ? amountFormat(Math.round(summaryData.totalPremiumValue))
                : "-"}
            </div>
            <div className="key mt-4">Loan Available</div>
            <div className="value">
              ₹{" "}
              {summaryData
                ? amountFormat(Math.round(summaryData.totalLoanAvailable))
                : "-"}
            </div>
          </div>
          <div>
            <div className="key">Surrender Value</div>
            <div className="value">
              ₹{" "}
              {summaryData
                ? amountFormat(Math.round(summaryData.totalSurrenderValue))
                : "-"}
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <section className="tre_bg-gray position-relative min-vh-100">
      {contextHolder}
      <OtherPageHeader
        classProps="bg-transparent"
        innerClassProps="bg-transparent"
      />
      <div className="container">
        <div className="tre_top-summary tre_Summary overflow-hide">
          {!isMobile && <SummaryComponent />}
        </div>

        <div className="tre_policy-block">
          <button
            className="add-policys"
            onClick={() => {
              // insurerListController();
              navigate("/phdashboard");
            }}
          >
            <i class="fa-solid fa-angle-left tre_flex-hcenter text-white policy-icon "></i>{" "}
            Dashboard
          </button>

          <div></div>
          <div className="policies-table">
            <Table
              bordered={true}
              loading={loading}
              className="table"
              dataSource={[...dataSource]}
              columns={columns}
              pagination={{
                pageSize: 10,
                total: paginationMetaData.count,
                onChange: change,
              }}
            />
          </div>
          {/* <RoleSwitch userRoles={userRoles} /> */}
        </div>
      </div>
    </section>
  );
}
